export default __webpack_public_path__ + "static/media/mongodb.389aa18a.svg";